module.exports = __webpack_public_path__ + "static/img/5.223bd02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/5.png
// module id = 4lgT
// module chunks = 0